import { render, staticRenderFns } from "./MailSettingFormDialog.vue?vue&type=template&id=f9c60f8e&scoped=true"
import script from "./MailSettingFormDialog.vue?vue&type=script&lang=js"
export * from "./MailSettingFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c60f8e",
  null
  
)

export default component.exports